import React from 'react';
import { Logo, Page } from './components';

export function MainView(): React.JSX.Element {
  return (
    <div className="reset-password-portlet">
      <div className="left-panel reset-content">
        <Logo />
        <Page />
      </div>
      <div className="right-panel image-column-right" />
    </div>
  );
}
